import { Injectable, Injector } from '@angular/core';
import { HttpRequest, HttpResponse, HttpInterceptor, HttpHandler, HttpSentEvent, HttpHeaderResponse, HttpProgressEvent, HttpUserEvent } from '@angular/common/http';

import { Observable, of, isObservable } from 'rxjs';

import { AppConfig } from '@awp/core/config';
import { tap, shareReplay } from 'rxjs/operators';

@Injectable()
export class ContentHttpInterceptor implements HttpInterceptor {

  private _appConfig: AppConfig;
  private _cache = new Map<string, any>();

  constructor(private injector: Injector) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpSentEvent | HttpHeaderResponse | HttpProgressEvent | HttpResponse<any> | HttpUserEvent<any> | any> {
    if (request.method !== 'GET'
      || request.url.startsWith('./assets')
      || !request.url.startsWith(this.appConfig.CMS_ROOT_API_URL)) {
      return next.handle(request);
    }

    const cachedResponse = this._cache.get(request.url);
    if (cachedResponse != null) {
      return isObservable(cachedResponse)
        ? cachedResponse
        : of(cachedResponse);
    }

    const requestHandle = next.handle(request)
      .pipe(
        tap(event => {
          if (event instanceof HttpResponse) {
            this._cache.set(request.url, event);
          }
        }),
        shareReplay(1)
      );

    this._cache.set(request.url, requestHandle);

    return requestHandle;
  }

  get appConfig(): AppConfig {
    if (this._appConfig == null) {
      this._appConfig = this.injector.get(AppConfig);
    }

    return this._appConfig;
  }
}
